var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "draggable",
        {
          staticClass: "shortlist shortlist-horizontal shortlist-col-4",
          attrs: {
            element: "ul",
            options: {
              group: "shortlist-rows",
              ghostClass: "ghost-class",
              handle: ".dragHandle",
            },
          },
          model: {
            value: _vm.localShortlist,
            callback: function ($$v) {
              _vm.localShortlist = $$v
            },
            expression: "localShortlist",
          },
        },
        _vm._l(_vm.shortlist, function (star, index) {
          return _c(
            "li",
            { key: star.id, staticClass: "row dragHandle handle" },
            [
              _c("div", { staticClass: "col-xs-4 col-sm-12" }, [
                _c("img", { attrs: { src: star.profile_image_url } }),
                _vm._v(" "),
                _c("span", { staticClass: "position" }, [
                  _vm._v(_vm._s(index + 1)),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "remove",
                    attrs: { "aria-label": "Remove" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleRemoveCallback(star.id)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [_vm._v("Remove")]),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-close" }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-8 col-sm-12 copy" }, [
                _c("div", { staticClass: "description" }, [
                  _c("h4", { staticClass: "truncate" }, [
                    _vm._v(
                      "\n            " + _vm._s(star.name) + "\n            "
                    ),
                    _c("span", { staticClass: "dragHandle handle" }, [
                      _c("i", { staticClass: "fa fa-ellipsis-v" }),
                    ]),
                  ]),
                  _vm._v(" "),
                  star.profile
                    ? _c("p", { staticClass: "truncate" }, [
                        _vm._v(_vm._s(star.profile.tagline)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  star.profile && !_vm.$hideSocialMediaReferences
                    ? _c("p", [
                        _c("i", {
                          class: `fab ${star.profile.highest_followers_icon}`,
                        }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(star.profile.highest_followers),
                          },
                        }),
                        _vm._v(" followers"),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cta" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "btn",
                        attrs: {
                          tag: "a",
                          to: {
                            name: "talent.profile.view",
                            params: { id: star.id, status: "event" },
                            query: {
                              shortlist: true,
                            },
                          },
                          target: "_blank",
                        },
                      },
                      [_vm._v("\n            View Bio\n          ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._l(_vm.shortlist, function (star) {
        return _c("input", {
          key: `input-${star.id}`,
          attrs: { type: "hidden", name: "shortlist[]" },
          domProps: { value: star.id },
        })
      }),
      _vm._v(" "),
      _vm.canShortlistItems
        ? _c(
            "a",
            {
              staticClass: "add-stars",
              attrs: {
                "data-toggle": "modal",
                "data-target": "#modal-add-talent",
                "data-backdrop": "static",
              },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$tc("request_stars.add_stars")) + "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$userIsAdmin || _vm.$userIsClient
        ? _c("shortlist-add-talent-modal", {
            key: "2",
            attrs: { booking: _vm.booking },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }